import React from 'react'
import MySites from "../components/ManageCenter/MySites";

  
class ManageCenter extends React.Component
{
    
    render() {

        
    

        return(
            <div>
                <MySites/>
            </div>
        );
    }
}
export default ManageCenter;


// WEBPACK FOOTER //
// ./src/pages/ManageCenter.js